import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import api from '../lib/api';
import { toast } from 'sonner';
import { LockSimple, Eye, EyeSlash } from '@phosphor-icons/react';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error('Password minimal 6 karakter');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      toast.success('Kata sandi berhasil diperbarui!');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal mengatur ulang kata sandi. Token mungkin tidak valid atau sudah kedaluwarsa.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-background flex flex-col">
        <Navbar />
        <main className="flex-1 flex items-center justify-center p-4">
          <div className="border-2 border-foreground bg-white p-8 shadow-brutal text-center max-w-sm">
            <h2 className="text-2xl font-bold mb-4">Link Tidak Valid</h2>
            <p className="text-sm mb-6">Tautan pengaturan ulang kata sandi tidak ditemukan atau tidak valid.</p>
            <button onClick={() => navigate('/login')} className="bg-primary text-white border-2 border-foreground px-6 py-2 font-bold shadow-brutal">
              Kembali ke Login
            </button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="max-w-md mx-auto px-4 py-16">
        <div className="border-2 border-foreground bg-white shadow-brutal-lg p-8">
          <h1 className="font-display text-4xl font-bold tracking-tight mb-2">Atur Ulang Sandi</h1>
          <p className="text-foreground/70 text-sm mb-6">
            Silakan masukkan kata sandi baru untuk akun Anda.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-widest font-bold block mb-2">Kata Sandi Baru</label>
              <div className="relative">
                <LockSimple size={18} weight="bold" className="absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  type={showPassword ? "text" : "password"}
                  required
                  autoFocus
                  minLength={6}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full border-2 border-foreground bg-white pl-10 pr-12 py-3 shadow-brutal-sm focus:outline-none focus:border-primary transition-all"
                  placeholder="Minimal 6 karakter"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground/50 hover:text-foreground transition-colors"
                >
                  {showPassword ? <EyeSlash size={20} weight="bold" /> : <Eye size={20} weight="bold" />}
                </button>
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full border-2 border-foreground bg-primary text-white px-4 py-3 font-bold uppercase tracking-wide shadow-brutal hover:shadow-brutal-sm transition-all disabled:opacity-60"
            >
              {loading ? 'Menyimpan...' : 'Perbarui Kata Sandi'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
